import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";



if ("caches" in window) {
  caches.keys().then(function (keyList) {
    return Promise.all(
      keyList.map(function (key) {
        return caches.delete(key);
      })
    );
  });
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// 예제 - 엔진 기본 예제 Demo
// new Engine({
//   canvas: document.querySelector('#canvas') as HTMLCanvasElement,
//   experience: DemoChromakey,
//   info: {
//     description: "A simple Avatar",
//     documentTitle: "AVATAR",
//     title: "Avatar Sample",
//   },
// });



